import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_DETRAN_CNH } from 'services/_path';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, LogonRestRequest } from './types';

// ACTIONS
import { logonRestSuccess, logonRestFailure } from './actions';

function* logonRestRequest(request: ReducerAction) {
	const { payload }: { payload: LogonRestRequest } = request;

	const response: ApiResponse = yield call(
		postApi,
		PATH_DETRAN_CNH,
		`eportal/${CHANNEL}/logon`,
		payload,
	);

	if (response.status === 200 || response.status === 204) {
		yield put(logonRestSuccess(response.data));
	} else {
		yield put(logonRestFailure(response));
	}
}

export default all([takeLatest(Types.LOGON_REST_REQUEST, logonRestRequest)]);
